import http from '@/api/common'

export default {
  getUsers (code, cb) {
    http.get(`http://httpstat.us/${code}`)
        .then(response => { cb(response) })
        .catch(error => { cb(error) })
  },
  updateUser (code, cb) {
    http.get(`http://httpstat.us/${code}`)
        .then(response => { cb(response) })
        .catch(error => { cb(error) })
  }
}



// WEBPACK FOOTER //
// ./src/api/endpoints/user.js